import React, { Fragment, useEffect, useState } from 'react'
import InputSearch from './InputSearch'
import authQueries from '../../queries/authQueries';
import SelectSearch from './SelectSearch';
import { ChevronDown, ChevronUp } from 'lucide-react';
import RegisteredCheckSearch from './RegisteredCheckSearch';
import { userStore } from '../../store/userStore';
import { useAdvancedSearch } from '../../store/advancedSearchStore';
import moment from 'moment';

const AdvancedSearch = () => {

    const store = userStore()

    const [expand, setExpand] = useState(false);
    const [masterData, setMasterData] = useState({})

    const name = useAdvancedSearch((state) => state.name);
    const mobile = useAdvancedSearch((state) => state.mobile);
    const email = useAdvancedSearch((state) => state.email);
    const visa = useAdvancedSearch((state) => state.visa);
    const status = useAdvancedSearch((state) => state.status);
    const reffered = useAdvancedSearch((state) => state.reffered);
    const appQualify = useAdvancedSearch((state) => state.appQualify);
    const intake = useAdvancedSearch((state) => state.intake);
    const office = useAdvancedSearch((state) => state.office);
    const district = useAdvancedSearch((state) => state.district);
    const college = useAdvancedSearch((state) => state.college);
    const appStatus = useAdvancedSearch((state) => state.appStatus);
    const hot = useAdvancedSearch((state) => state.hot);
    const warm = useAdvancedSearch((state) => state.warm);
    const cold = useAdvancedSearch((state) => state.cold);
    const hold = useAdvancedSearch((state) => state.hold);
    const long = useAdvancedSearch((state) => state.long);
    const registered = useAdvancedSearch((state) => state.registered);
    const counselor = useAdvancedSearch((state) => state.counselor);
    const documentStaff = useAdvancedSearch((state) => state.documentStaff);
    const pgCoordinator = useAdvancedSearch((state) => state.pgCoordinator);
    const admissionStaff = useAdvancedSearch((state) => state.admissionStaff);
    const feeCoordinator = useAdvancedSearch((state) => state.feeCoordinator);
    const visaStaff = useAdvancedSearch((state) => state.visaStaff);
    const createdFrom = useAdvancedSearch((state) => state.createdFrom);
    const createdTo = useAdvancedSearch((state) => state.createdTo);

    const setName = useAdvancedSearch((state) => state.setName);
    const setMobile = useAdvancedSearch((state) => state.setMobile);
    const setEmail = useAdvancedSearch((state) => state.setEmail);
    const setVisa = useAdvancedSearch((state) => state.setVisa);
    const setStatus = useAdvancedSearch((state) => state.setStatus);
    const setReffered = useAdvancedSearch((state) => state.setReffered);
    const setAppQualify = useAdvancedSearch((state) => state.setAppQualify);
    const setIntake = useAdvancedSearch((state) => state.setIntake);
    const setOffice = useAdvancedSearch((state) => state.setOffice);
    const setDistrict = useAdvancedSearch((state) => state.setDistrict);
    const setCollege = useAdvancedSearch((state) => state.setCollege);
    const setAppStatus = useAdvancedSearch((state) => state.setAppStatus);
    const setHot = useAdvancedSearch((state) => state.setHot);
    const setWarm = useAdvancedSearch((state) => state.setWarm);
    const setCold = useAdvancedSearch((state) => state.setCold);
    const setHold = useAdvancedSearch((state) => state.setHold);
    const setLong = useAdvancedSearch((state) => state.setLong);
    const setRegistered = useAdvancedSearch((state) => state.setRegistered);
    const setCounselor = useAdvancedSearch((state) => state.setCounselor);
    const setDocumentStaff = useAdvancedSearch((state) => state.setDocumentStaff);
    const setPgCoordinator = useAdvancedSearch((state) => state.setPgCoordinator);
    const setAdmissionStaff = useAdvancedSearch((state) => state.setAdmissionStaff);
    const setFeeCoordinator = useAdvancedSearch((state) => state.setFeeCoordinator);
    const setVisaStaff = useAdvancedSearch((state) => state.setVisaStaff);
    const setCreatedFrom = useAdvancedSearch((state) => state.setCreatedFrom);
    const setCreatedTo = useAdvancedSearch((state) => state.setCreatedTo);

    const advancedMasterList = authQueries.useAdvancedSearchMutation(
        (response) => {
            setMasterData(response?.data)
        }
    );

    useEffect(() => {
        advancedMasterList.mutateAsync({visa: visa})
    }, [visa])

    const bmOffice = store?.user?.office?.map(item=>{
        return item?.office
    })

    const chipData = [
        {
            id: 1,
            label: "HOT",
            state: hot,
            setState: setHot,
        },
        {
            id: 2,
            label: "WARM",
            state: warm,
            setState: setWarm,
        },
        {
            id: 3,
            label: "COLD",
            state: cold,
            setState: setCold,
        },
        {
            id: 4,
            label: "LONG TERM",
            state: long,
            setState: setLong,
        },
        {
            id: 5,
            label: "ON HOLD",
            state: hold,
            setState: setHold,
        }
    ]

    const inputSearchArry = [
        {
            label: "Applicant Name",
            size: 2,
            state: name,
            setState: setName,
            type: "text",
            input: InputSearch,
            simple: true
        },
        {
            label: "Contact Number",
            size: 2,
            state: mobile,
            setState: setMobile,
            type: "number",
            input: InputSearch,
            simple: true
        },
        {
            label: "Email",
            size: 2,
            state: email,
            setState: setEmail,
            type: "text",
            input: InputSearch,
            simple: true
        },
        {
            label: "Visa Type",
            size: 2,            
            state: visa,
            setState: setVisa,
            input: SelectSearch,
            value:  (store?.user?.role === "MANAGER" || store?.user?.role === "REGISTRATION" || store?.user?.role === "SENIORPROGRAMMANAGER") ? store?.user?.visa : masterData?.visatype,
            visa: (store?.user?.role === "MANAGER" || store?.user?.role === "REGISTRATION" || store?.user?.role === "SENIORPROGRAMMANAGER") ? true : false,
            name: 'description',
            simple: true
        },
        {
            label: "Prospect Status",
            size: 2,            
            state: status,
            setState: setStatus,
            input: SelectSearch,
            value: masterData?.prospectstatus,
            name: 'name',
            simple: true
        },
        {
            label: "Registration Status",
            size: 2,            
            state: registered,
            setState: setRegistered,
            input: RegisteredCheckSearch,
            hidden: store?.user?.role === "ADMISSIONSTAFF" ? true : false,
            simple: true
        },
        {
            label: "Branch Office",
            size: 2,            
            state: office,
            setState: setOffice,
            input: SelectSearch,
            value: store?.user?.role === "BMANAGER" ? bmOffice : masterData?.office,
            name: 'name',
            simple: store?.user?.role !== "ADMISSIONSTAFF" ? false: true,
        },
        {
            label: "District",
            size: 2,            
            state: district,
            setState: setDistrict,
            input: SelectSearch,
            value: masterData?.district,
            name: 'name',
            simple: false
        },
        {
            label: "Intake",
            size: 2,            
            state: intake,
            setState: setIntake,
            input: SelectSearch,
            value: masterData?.intake,
            name: 'intake',
            simple: false
        },
        {
            label: "College",
            size: 2,            
            state: college,
            setState: setCollege,
            input: SelectSearch,
            value: masterData?.college,
            name: 'name',
            simple: false,
            hidden: store?.user?.role !== "ADMISSIONSTAFF" ? true : false
        },
        {
            label: "Refferred By",
            size: 2,            
            state: reffered,
            setState: setReffered,
            input: SelectSearch,
            value: masterData?.refferal,
            name: 'refferal',
            simple: false
        },
        {
            label: "Applicant Qualification",
            size: 2,            
            state: appQualify,
            setState: setAppQualify,
            input: SelectSearch,
            value: masterData?.qualification,
            name: 'name',
            simple: false
        },
        {
            label: "Application Status",
            size: 2,            
            state: appStatus,
            setState: setAppStatus,
            input: SelectSearch,
            value: masterData?.applicationstatus,
            name: 'name',
            simple: false
        }
    ]

    const userSearchArry = [
        {
            label: "Counselor",
            size: 2,            
            state: counselor,
            setState: setCounselor,
            input: SelectSearch,
            value: store.user.role === "SENIORPROGRAMMANAGER" ? masterData?.seniorpgmusers : masterData?.user?.filter(user => user.roles.includes(3)),
            hidden: store?.user?.role === "COUNSELOR" ? true : false,
            name: 'name',
            simple: false,
        },
        {
            label: "Document Staff",
            size: 2,            
            state: documentStaff,
            setState: setDocumentStaff,
            input: SelectSearch,
            value: masterData?.user?.filter(user => user.roles.includes(5)),
            hidden: store?.user?.role === "DOCUMENTSTAFF" ? true : false,
            name: 'name',
            simple: false,
        },
        {
            label: "Program Coordinator",
            size: 2,            
            state: pgCoordinator,
            setState: setPgCoordinator,
            input: SelectSearch,
            value: masterData?.user?.filter(user => user.roles.includes(6)),
            hidden: store?.user?.role === "PROGRAMCOORDINATOR" ? true : false,
            name: 'name',
            simple: false,
        },
        {
            label: "Admission Staff",
            size: 2,            
            state: admissionStaff,
            setState: setAdmissionStaff,
            input: SelectSearch,
            value: masterData?.user?.filter(user => user.roles.includes(7)),
            hidden: store?.user?.role === "ADMISSIONSTAFF" ? true : false,
            name: 'name',
            simple: false,
        },
        {
            label: "Fee Coordinator",
            size: 2,            
            state: feeCoordinator,
            setState: setFeeCoordinator,
            input: SelectSearch,
            value: masterData?.user?.filter(user => user.roles.includes(9)),
            name: 'name',
            simple: false,
        },
        {
            label: "Visa Staff",
            size: 2,            
            state: visaStaff,
            setState: setVisaStaff,
            input: SelectSearch,
            value: masterData?.user?.filter(user => user.roles.includes(8)),
            name: 'name',
            simple: false,
        },
    ]

    const dateFilterArry = [
        
        {
            label: "From Date",
            size: 2,            
            state: createdFrom,
            setState: setCreatedFrom,
            type: "date",
            input: InputSearch,
            name: 'name',
            simple: false,
        },
        {
            label: "To Date",
            size: 2,            
            state: createdTo,
            setState: setCreatedTo,
            type: "date",
            input: InputSearch,
            name: 'name',
            simple: false,
        },
    ]


  return (
    <Fragment>
        <div className="grid grid-cols-12 max-[1389px]:grid-cols-10 max-[1163px]:grid-cols-8 max-[929px]:grid-cols-6 max-[585px]:grid-cols-4 max-[445px]:grid-cols-2 gap-x-6 gap-y-5 !mb-5">
            {
                inputSearchArry?.map((item, index)=> {
                    if(item?.blank && !item?.hidden){
                        return(
                        <div className={`col-span-${item?.size} flex flex-col gap-2`}/>
                        )
                    }
                    if(item?.hidden){
                        return
                    }
                    return(
                    <Fragment key={index}>
                        {
                            (item?.simple || expand) &&
                            <div key={index} className={`col-span-${item?.size} flex flex-col gap-2`}>
                                <item.input item={item} />
                            </div>
                        }
                    </Fragment>
                )})
            }
        </div>        
        
        {
            expand &&
            <Fragment>
                <div className="grid grid-cols-12 max-[1389px]:grid-cols-10 max-[1163px]:grid-cols-8 max-[929px]:grid-cols-6 max-[585px]:grid-cols-4 max-[445px]:grid-cols-2 gap-x-6 gap-y-5 !mb-5">
                    {
                        userSearchArry?.map((item, index)=> {
                            if(item?.blank && !item?.hidden){
                                return(
                                <div className={`col-span-${item?.size} flex flex-col gap-2`}/>
                                )
                            }
                            if(item?.hidden){
                                return
                            }
                            return(
                            <Fragment key={index}>
                                {
                                    (item?.simple || expand) &&
                                    <div key={index} className={`col-span-${item?.size} flex flex-col gap-2`}>
                                        <item.input item={item} />
                                    </div>
                                }
                            </Fragment>
                        )})
                    }
                </div>

                <div className="grid grid-cols-12 max-[1389px]:grid-cols-10 max-[1163px]:grid-cols-8 max-[929px]:grid-cols-6 max-[585px]:grid-cols-4 max-[445px]:grid-cols-2 gap-x-6 gap-y-5 !mb-5">
                    {
                        dateFilterArry?.map((item, index)=> {
                            if(item?.blank && !item?.hidden){
                                return(
                                <div className={`col-span-${item?.size} flex flex-col gap-2`}/>
                                )
                            }
                            if(item?.hidden){
                                return
                            }
                            return(
                            <Fragment key={index}>
                                {
                                    (item?.simple || expand) &&
                                    <div key={index} className={`col-span-${item?.size} flex flex-col gap-2`}>
                                        <item.input item={item} />
                                    </div>
                                }
                            </Fragment>
                        )})
                    }
                </div>
            </Fragment>
        }
        
        {(expand && store?.user?.role !== "ADMISSIONSTAFF") &&
            <div className='grid-cols-2 !mb-5'>
                <div className="col-span-2 max-[585px]:col-span-4 max-[445px]:col-span-2 justify-center flex flex-col gap-2">
                    <div className="text-[12px] h-4 font-[500]">Profile Status</div>
                    <div className="flex gap-2 items-center flex-wrap">
                        {
                            chipData.map((item, index)=> (
                                <div
                                key={index} 
                                onClick={()=>{item?.state ? item?.setState(false):item?.setState(true)}} 
                                className={`${item.state ? "bg-[#28a745]" : "bg-[#ff4d4f]"} flex items-center h-[30px] rounded-full cursor-pointer justify-start`}
                                >
                                    <div className="text-[24px] flex pl-[4px]">
                                        {
                                            item.state ?
                                            <i className='icon-cancel1 text-white'/>:
                                            <i className='icon-plus1 text-white' />
                                        }
                                    </div>
                                    <div className="text-[10px] text-white font-semibold pl-2 pr-3">
                                        {item.label} Client
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        }
        
        <div className="row advance-search-btn-cntnr">
            <div className="col-md-12 mb-6" style={{ position: 'relative' }}>
                <hr />
                <button onClick={() => { setExpand(!expand) }} className="advance-search-btn search">
                    {
                        !expand ? 
                        <div className='flex gap-2'>
                            <div>Advanced Search</div>
                            <div><ChevronDown size="16" /></div>
                        </div>:
                        <div className='flex gap-2'>
                            <div>Simple Search</div>
                            <div><ChevronUp size="16" /></div>
                        </div>
                    }
                </button>
            </div>
        </div>
      
    </Fragment>
  )
}

export default AdvancedSearch
